import module from 'viaticos/module.js'
import template from './template.html'

export class ViaticosConfiguracionProyectoDiastoleranciaComponent {
  idProyecto
  diastolerancia
  activareliminar = false
  activarmodificar = false

  constructor ($state) {
    this.$state = $state
  }

  regresar () {
    this.$state.go('.^')
  }

  editar (diastolerancia) {
    this.diastolerancia = diastolerancia
    this.activarmodificar = false
  }
}

module.component('viaticosConfiguracionProyectoDiastolerancia', {
  controller: ViaticosConfiguracionProyectoDiastoleranciaComponent,
  template,
  bindings: {
    idProyecto: '<',
    diastolerancia: '<',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/diastolerancia/component.js